import ActivityCard from './activity-card';

export interface ActivityCardListResponse {
	listed: ActivityCard[];
}
